import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-8 flex items-start justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-700 text-3xl font-semibold mb-1" }, "Lingo Data")
], -1)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "[&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5"
}
const _hoisted_6 = { class: "mb-6 border-b border-gray-200" }
const _hoisted_7 = { class: "-mb-px flex items-center gap-6" }
const _hoisted_8 = { class: "mb-6 flex flex-wrap items-center gap-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "grade-filter",
  class: "text-gray-800 text-sm font-semibold"
}, " Class(es) / Grade(s) ", -1)
const _hoisted_10 = { class: "min-w-[18rem]" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "bg-white rounded-lg border border-gray-300 overflow-hidden" }
const _hoisted_13 = { class: "overflow-x-auto" }
const _hoisted_14 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_15 = { class: "bg-gray-50" }
const _hoisted_16 = { class: "flex items-center gap-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Student", -1)
const _hoisted_18 = { class: "flex items-center gap-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Spelling Lv", -1)
const _hoisted_20 = { class: "flex items-center gap-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Gaps Filled", -1)
const _hoisted_22 = { class: "flex items-center gap-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Vocabulary Lv", -1)
const _hoisted_24 = { class: "flex items-center gap-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Gaps Filled", -1)
const _hoisted_26 = { class: "flex items-center gap-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Grammar Lv", -1)
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Gaps Filled", -1)
const _hoisted_30 = { class: "flex items-center gap-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Total Filled", -1)
const _hoisted_32 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap border-r border-gray-200" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700" }
const _hoisted_36 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700 border-r border-gray-200" }
const _hoisted_37 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700" }
const _hoisted_38 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700 border-r border-gray-200" }
const _hoisted_39 = {
  key: 0,
  class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700"
}
const _hoisted_40 = {
  key: 1,
  class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700 border-r border-gray-200"
}
const _hoisted_41 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-700" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  colspan: "8",
  class: "px-6 py-10 text-center text-sm text-gray-500"
}
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-gray-900 mb-1" }, "No Students found", -1)
const _hoisted_46 = {
  key: 0,
  class: "p-4 text-sm text-gray-500 bg-gray-50 border-t border-gray-200"
}
const _hoisted_47 = {
  key: 0,
  class: "mt-6 flex items-center justify-between text-sm text-gray-500"
}

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLingoStore } from "@/stores/lingoStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { Learner } from "@/interfaces/learner.interface";
import { KnowledgeComponent } from "@/interfaces/lingo.interfaces";
import { ChevronUpDownIcon, QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import { UserIcon } from "@heroicons/vue/24/solid";

import * as XLSX from "xlsx";
import { showToast } from "@/utils/toastUtils";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";

const BATCH_SIZE = 50;
type SortKey =
  | "student"
  | "spellingLevel"
  | "spellingGapsFilled"
  | "vocabularyLevel"
  | "vocabularyGapsFilled"
  | "grammarLevel"
  | "grammarGapsFilled"
  | "totalFilled";

type StudentDisplay = Learner & { displayName: string; mathClasses: string[]; englishClasses: string[] };

const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export default /*#__PURE__*/_defineComponent({
  __name: 'LingoLevelsGapsFilled',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const schoolStore = useSchoolStore();

// Grammar is controlled by the selected school's setting. MUST be a computed,
// not a plain const: the school arrives from an un-awaited fetch after setup
// runs, so a snapshot taken here would be permanently false.
//
// Because this is a ComputedRef, every usage in JS below needs `.value`. A
// ComputedRef is always truthy, so forgetting one silently keeps grammar in
// the arithmetic and the CSV while the columns are hidden.
const grammarEnabled = computed(() => schoolStore.grammarEnabled);
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const lingoStore = useLingoStore();

const pages = [
  {
    name: 'Lingo Data',
    path: '/main/lingo-data'
  }
];

const gradeFilter = ref<string>("");
const sortKey = ref<SortKey>("student");
const sortAsc = ref(true);
const itemsPerPage = ref<number>(BATCH_SIZE);
const searchQuery = ref<string>('');

const displayStudents = computed<StudentDisplay[]>(() => {
  const active = (learnerStore.schoolLearners || []).filter(l => l.status === "active");
  return active.map(learner => {
    const mathClasses = learner.classes?.filter(c => c.subject.code === "MATHS").map(c => c.name) || [];
    const englishClasses = learner.classes?.filter(c => c.subject.code === "ENGLISH").map(c => c.name) || [];
    return {
      ...learner,
      displayName: `${learner.lastName}, ${learner.firstName}`,
      mathClasses,
      englishClasses,
    };
  });
});

const gradesWithClasses = computed<number[]>(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure) return [];
  return [...new Set(structure.classGroups.filter(c => c.gradeLevel != null).map(c => c.gradeLevel))].sort((a, b) => a - b);
});

const subjectsPresent = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure || !structure.subjectsAvailable) {
    const set = new Set<string>();
    learnerStore.schoolLearners?.forEach(l => l.classes?.forEach(c => set.add(c.subject.code)));
    return { bothPresent: set.has("MATHS") && set.has("ENGLISH") };
  }
  const codes = structure.subjectsAvailable.map(s => s.code);
  return { bothPresent: codes.includes("MATHS") && codes.includes("ENGLISH") };
});

const classesByGrade = computed<Record<number, Array<{ value: string; label: string; sortKey: string }>>>(() => {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure) return {};
  const out: Record<number, Array<{ value: string; label: string; sortKey: string }>> = {};
  for (const grade of gradesWithClasses.value) {
    out[grade] = structure.classGroups
      .filter(c => c.gradeLevel === grade)
      .map(cls => {
        const subjectName = subjectStore.getSubjectNameById(cls.subject);
        const suffix = subjectsPresent.value.bothPresent ? `${subjectName}, ` : "";
        const label = `${cls.name} (${suffix}Grade ${grade})`;
        return { value: cls.name, label, sortKey: label };
      })
      .sort((a, b) => a.sortKey.localeCompare(b.sortKey));
  }
  return out;
});

const gradeFilterOptions = computed(() =>
  gradesWithClasses.value.map(grade => ({
    groupLabel: `Grade ${grade} (All)`,
    groupValue: `grade-${grade}`,
    items: (classesByGrade.value[grade] || []).map(cls => ({ label: cls.label, value: cls.value })),
  })),
);

const filteredStudents = computed<StudentDisplay[]>(() => {
  let list = [...displayStudents.value];

  if (gradeFilter.value) {
    if (gradeFilter.value.startsWith("grade-")) {
      const gradeLevel = parseInt(gradeFilter.value.replace("grade-", ""));
      list = list.filter(s => {
        const allClassNames = [...s.mathClasses, ...s.englishClasses];
        return allClassNames.some(name => {
          const grp = schoolStore.currentSchoolStructure?.classGroups.find(c => c.name === name);
          return grp?.gradeLevel === gradeLevel;
        });
      });
    } else {
      list = list.filter(s => s.mathClasses.includes(gradeFilter.value) || s.englishClasses.includes(gradeFilter.value));
    }
  }

  // Search
  if (searchQuery.value.trim()) {
    const q = searchQuery.value.toLowerCase()
    list = list.filter(s =>
      (s.displayName || '').toLowerCase().includes(q) ||
      (s.email || '').toLowerCase().includes(q) ||
      (s.firstName || '').toLowerCase().includes(q) ||
      (s.lastName || '').toLowerCase().includes(q)
    )
  }

  return list;
});

const levelSortValue = (label: string): number => {
  const match = /^Level\s+(\d+)\+?$/.exec(String(label || "").trim());
  if (!match) return 0;
  const n = Number(match[1]);
  return Number.isFinite(n) ? n : 0;
};

const allRows = computed(() => {
  return filteredStudents.value.map(student => {
    const lingoData = lingoStore.getLingoDataByStudentId(String(student._id));

    // Get stats from performanceMetrics directly, matching LingoLevelsAndGapsFilledView
    const metrics = lingoData?.performanceMetrics || null;

    // Helper to extract level string safely
    const getLevelStr = (levelNum: number, diagnosticComplete: boolean) => {
      let levelStr = levelNum >= 7 ? "Level 7+" : `Level ${levelNum}`;
      return diagnosticComplete ? levelStr : `${levelStr}*`;
    };

    // Spelling
    const spellingMetrics = metrics?.spelling;
    const isSpellingDiagnosticComplete = lingoData?.spellingDiagnosticComplete !== false;
    const spellingLevel = spellingMetrics ? getLevelStr(spellingMetrics.currentLevel, isSpellingDiagnosticComplete) : "Level 1";
    const spellingGapsFilled = spellingMetrics?.totalGapsFilled || 0;

    // Vocabulary
    const vocabMetrics = metrics?.vocabulary;
    const isVocabDiagnosticComplete = lingoData?.vocabularyDiagnosticComplete !== false;
    const vocabularyLevel = vocabMetrics ? getLevelStr(vocabMetrics.currentLevel, isVocabDiagnosticComplete) : "Level 1";
    const vocabularyGapsFilled = vocabMetrics?.totalGapsFilled || 0;

    // Grammar (placeholder for now/future). No grammar diagnostic flag exists
    // yet, so `!== false` yields true and grammar never renders a spurious "*".
    const grammarMetrics = metrics?.grammar;
    const isGrammarDiagnosticComplete = lingoData?.grammarDiagnosticComplete !== false;
    const grammarLevel = grammarMetrics ? getLevelStr(grammarMetrics.currentLevel, isGrammarDiagnosticComplete) : "Level 1";
    const grammarGapsFilled = grammarMetrics?.totalGapsFilled || 0;

    // Grammar only counts toward the total when its columns are visible, so
    // Total Filled always reconciles with the columns shown beside it.
    const totalFilled =
      spellingGapsFilled + vocabularyGapsFilled + (grammarEnabled.value ? grammarGapsFilled : 0);

    return {
      studentId: String(student._id),
      student,
      spellingLevel,
      spellingGapsFilled,
      vocabularyLevel,
      vocabularyGapsFilled,
      grammarLevel,
      grammarGapsFilled,
      totalFilled,
      // Derive the footnote flag from the diagnostic-complete booleans (not from
      // an "*" in the level string) so it matches the export exactly — a freshly
      // placed student with no metrics is still flagged incomplete.
      diagnosticIncomplete: !isSpellingDiagnosticComplete || !isVocabDiagnosticComplete,
    };
  });
});

const hasIncompleteDiagnostic = computed(() => {
  return allRows.value.some(row => row.diagnosticIncomplete);
});

const sortedRows = computed(() => {
  const rows = [...allRows.value];
  const dir = sortAsc.value ? 1 : -1;
  rows.sort((a, b) => {
    switch (sortKey.value) {
      case "student":
        return dir * a.student.displayName.localeCompare(b.student.displayName);
      case "spellingLevel":
        return dir * (levelSortValue(a.spellingLevel) - levelSortValue(b.spellingLevel));
      case "spellingGapsFilled":
        return dir * (a.spellingGapsFilled - b.spellingGapsFilled);
      case "vocabularyLevel":
        return dir * (levelSortValue(a.vocabularyLevel) - levelSortValue(b.vocabularyLevel));
      case "vocabularyGapsFilled":
        return dir * (a.vocabularyGapsFilled - b.vocabularyGapsFilled);
      case "grammarLevel":
        return dir * (levelSortValue(a.grammarLevel) - levelSortValue(b.grammarLevel));
      case "grammarGapsFilled":
        return dir * (a.grammarGapsFilled - b.grammarGapsFilled);
      case "totalFilled":
        return dir * (a.totalFilled - b.totalFilled);
      default:
        return 0;
    }
  });
  return rows;
});

const paginatedStudents = computed(() => sortedRows.value.map(r => r.student).slice(0, itemsPerPage.value));
const startIndex = computed(() => 0);
const endIndex = computed(() => Math.min(itemsPerPage.value, filteredStudents.value.length));
const hasMore = computed(() => filteredStudents.value.length > itemsPerPage.value);
const nextBatchSize = computed(() => Math.min(50, filteredStudents.value.length - itemsPerPage.value));

const toggleSort = (key: SortKey) => {
  if (sortKey.value === key) {
    sortAsc.value = !sortAsc.value;
    return;
  }
  sortKey.value = key;
  sortAsc.value = true;
};
const showMore = () => {
  itemsPerPage.value += BATCH_SIZE;
};

const goToStudentData = (student: Learner) => {
  router.push({ name: "lingo-student-data", params: { studentId: String(student._id) } });
};

// --- Data refresh (every 5 minutes)
let refreshIntervalId: ReturnType<typeof setInterval> | null = null;
const isRefreshing = ref(false);

const refreshStudentData = async () => {
  const schoolId = schoolStore.currentSchoolStructure?._id;
  if (!schoolId || isRefreshing.value) return;

  isRefreshing.value = true;
  try {
    await learnerStore.fetchSchoolLearners(schoolId);
  } catch (error) {
    console.error("Failed to refresh learner data:", error);
  } finally {
    isRefreshing.value = false;
  }
};

const shouldRefreshData = () => {
  const lastFetch = learnerStore.lastFetchTimestamp;
  if (!lastFetch) return true; // Never fetched
  return Date.now() - lastFetch > REFRESH_INTERVAL_MS;
};

onMounted(async () => {
  // Check if data needs refresh (5 minutes expired)
  if (shouldRefreshData()) {
    await refreshStudentData();
  }

  // Set up auto-refresh every 5 minutes
  refreshIntervalId = setInterval(refreshStudentData, REFRESH_INTERVAL_MS);

  const classId = route.query.classId as string | undefined;
  if (!classId) return;
  const cls = schoolStore.currentSchoolStructure?.classGroups.find(c => c._id === classId);
  if (cls) gradeFilter.value = cls.name;
});

onUnmounted(() => {
  // Clear the refresh interval when leaving the page
  if (refreshIntervalId) {
    clearInterval(refreshIntervalId);
    refreshIntervalId = null;
  }
});

// Fetch lingo data for the currently visible students
const lastFetchedKey = ref<string>("");
watch(
  [paginatedStudents, filteredStudents, sortKey],
  async ([visible, filtered, key]) => {
    const ids =
      key === "student"
        ? (visible || []).map(s => String(s._id)).filter(Boolean)
        : (filtered || []).map(s => String(s._id)).filter(Boolean);

    const fetchKey = `${key}|${ids.join(",")}`;
    if (!ids.length || fetchKey === lastFetchedKey.value) return;
    lastFetchedKey.value = fetchKey;
    await lingoStore.fetchStudentLingoData({ studentIds: ids });
  },
  { immediate: true },
);



const tableRows = computed(() => sortedRows.value.slice(0, itemsPerPage.value));

const loadingExport = ref(false);

const addBoldHeaders = (worksheet: XLSX.WorkSheet, data: Array<Array<string | number>>) => {
  if (!data || data.length === 0) return;
  const headers = data[0];
  headers.forEach((_, index: number) => {
    const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = { font: { bold: true } };
    }
  });
};

async function exportLingoData() {
  if (loadingExport.value) return;
  loadingExport.value = true;

  try {
    const studentsToExport = filteredStudents.value;
    if (studentsToExport.length === 0) {
      showToast({ text: "No students to export.", type: "error", icon: ExclamationCircleIcon });
      return;
    }

    const studentIds = studentsToExport.map(s => s._id);
    await lingoStore.fetchStudentLingoData({ studentIds });

    let hasIncomplete = false;

    const rows = studentsToExport.map(student => {
      const lingoData = lingoStore.getLingoDataByStudentId(student._id);
      // Use performance metrics for export as well
      const metrics = lingoData?.performanceMetrics || null;

      // Helper to extract level string safely
      const getLevelStr = (levelNum: number, diagnosticComplete: boolean) => {
        let levelStr = levelNum >= 7 ? "Level 7+" : `Level ${levelNum}`;
        return diagnosticComplete ? levelStr : `${levelStr}*`;
      };

      // Spelling
      const spellingMetrics = metrics?.spelling;
      const isSpellingDiagnosticComplete = lingoData?.spellingDiagnosticComplete !== false;
      const spellingLevel = spellingMetrics ? getLevelStr(spellingMetrics.currentLevel, isSpellingDiagnosticComplete) : "Level 1";
      const spellingGapsFilled = spellingMetrics?.totalGapsFilled || 0;
      if (!isSpellingDiagnosticComplete) hasIncomplete = true;

      // Vocabulary
      const vocabMetrics = metrics?.vocabulary;
      const isVocabDiagnosticComplete = lingoData?.vocabularyDiagnosticComplete !== false;
      const vocabularyLevel = vocabMetrics ? getLevelStr(vocabMetrics.currentLevel, isVocabDiagnosticComplete) : "Level 1";
      const vocabularyGapsFilled = vocabMetrics?.totalGapsFilled || 0;
      if (!isVocabDiagnosticComplete) hasIncomplete = true;

      // Grammar. No grammar diagnostic flag exists yet, so `!== false` yields
      // true and grammar never renders a spurious "*".
      const grammarMetrics = metrics?.grammar;
      const isGrammarDiagnosticComplete = lingoData?.grammarDiagnosticComplete !== false;
      const grammarLevel = grammarMetrics ? getLevelStr(grammarMetrics.currentLevel, isGrammarDiagnosticComplete) : "Level 1";
      const grammarGapsFilled = grammarMetrics?.totalGapsFilled || 0;

      const totalFilled =
        spellingGapsFilled + vocabularyGapsFilled + (grammarEnabled.value ? grammarGapsFilled : 0);

      return [
        student.displayName,
        spellingLevel,
        spellingGapsFilled,
        vocabularyLevel,
        vocabularyGapsFilled,
        ...(grammarEnabled.value ? [grammarLevel, grammarGapsFilled] : []),
        totalFilled,
      ];
    });

    // Keep the export columns in step with the table: grammar is omitted
    // entirely while the flag is off.
    const headers = [
      "Student",
      "Spelling Level",
      "Spelling Gaps Filled",
      "Vocabulary Level",
      "Vocabulary Gaps Filled",
      ...(grammarEnabled.value ? ["Grammar Level", "Grammar Gaps Filled"] : []),
      "Total Filled",
    ];

    rows.sort((a, b) => String(a[0]).localeCompare(String(b[0])));

    const finalData = [headers, ...rows];

    if (hasIncomplete) {
      finalData.push([]);
      finalData.push(["*Early-stage level estimate. Full placement occurs after a small number of diagnostic lists."]);
    }

    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    addBoldHeaders(worksheet, finalData);

    worksheet["!cols"] = headers.map(() => ({ wch: 20 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    const timestamp = new Date().toISOString().slice(0, 10);
    const filename = `Levels_Gaps_Filled_${timestamp}.xlsx`;

    XLSX.writeFile(workbook, filename);

    showToast({ text: "Export complete.", type: "success", icon: CheckCircleIcon });
  } catch (error) {
    console.error("Export failed", error);
    showToast({ text: "Export failed. Please try again.", type: "error", icon: ExclamationCircleIcon });
  } finally {
    loadingExport.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { pages: pages }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center gap-2 rounded-lg border border-gray-300 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-50",
        onClick: exportLingoData,
        disabled: loadingExport.value
      }, [
        (loadingExport.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_spinner_loader, {
                color: 'text-gray-600',
                class: "h-5 w-5"
              })
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-export',
                title: 'rl export',
                "aria-hidden": "true"
              })
            ])),
        _createTextVNode(" Export ")
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: { name: 'lingo-data' },
          class: _normalizeClass(["whitespace-nowrap border-b-2 py-2 px-1 text-sm font-semibold", _unref(route).name === 'lingo-data'
          ? 'border-indigo-600 text-indigo-600'
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Overview ")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: { name: 'lingo-levels-gaps-filled' },
          class: _normalizeClass(["whitespace-nowrap border-b-2 py-2 px-1 text-sm font-semibold", _unref(route).name === 'lingo-levels-gaps-filled'
          ? 'border-indigo-600 text-indigo-600'
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'])
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Levels and Gaps Filled ")
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_FormKit, {
          type: "treeSelect",
          name: "gradeFilter",
          modelValue: gradeFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((gradeFilter).value = $event)),
          selectOptions: gradeFilterOptions.value,
          classes: { outer: 'w-full' }
        }, null, 8, ["modelValue", "selectOptions"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FormKit, {
          type: "text",
          name: "search",
          placeholder: 'Search',
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
          classes: { input: 'pl-10' },
          "prefix-icon": "search"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", _hoisted_15, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100 border-r border-gray-300",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('student')))
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ]),
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort('spellingLevel')))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ]),
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100 border-r border-gray-300",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort('spellingGapsFilled')))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ]),
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSort('vocabularyLevel')))
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ]),
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100 border-r border-gray-300",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSort('vocabularyGapsFilled')))
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ]),
              (grammarEnabled.value)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 0,
                    class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSort('grammarLevel')))
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (grammarEnabled.value)
                ? (_openBlock(), _createElementBlock("th", {
                    key: 1,
                    class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100 border-r border-gray-300",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSort('grammarGapsFilled')))
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("th", {
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleSort('totalFilled')))
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5" })
                ])
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableRows.value, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.studentId,
                class: "hover:bg-gray-50"
              }, [
                _createElementVNode("td", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-sm font-medium text-indigo-600 hover:text-indigo-500 truncate",
                    onClick: ($event: any) => (goToStudentData(row.student))
                  }, _toDisplayString(row.student.displayName), 9, _hoisted_34)
                ]),
                _createElementVNode("td", _hoisted_35, _toDisplayString(row.spellingLevel), 1),
                _createElementVNode("td", _hoisted_36, _toDisplayString(row.spellingGapsFilled), 1),
                _createElementVNode("td", _hoisted_37, _toDisplayString(row.vocabularyLevel), 1),
                _createElementVNode("td", _hoisted_38, _toDisplayString(row.vocabularyGapsFilled), 1),
                (grammarEnabled.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString(row.grammarLevel), 1))
                  : _createCommentVNode("", true),
                (grammarEnabled.value)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(row.grammarGapsFilled), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_41, _toDisplayString(row.totalFilled), 1)
              ]))
            }), 128)),
            (tableRows.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                  _createElementVNode("td", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_unref(UserIcon), { class: "h-10 w-10 mx-auto text-gray-400" })
                    ]),
                    _hoisted_45,
                    _createElementVNode("div", null, "Try changing the Class(es) / Grade(s) filter" + _toDisplayString(searchQuery.value ? ' or your search.' : '.'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (hasIncompleteDiagnostic.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, " *Early-stage level estimate. Full placement occurs after a small number of diagnostic lists. "))
        : _createCommentVNode("", true)
    ]),
    (filteredStudents.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", null, "Showing " + _toDisplayString(startIndex.value + 1) + "-" + _toDisplayString(endIndex.value) + " of " + _toDisplayString(filteredStudents.value.length) + " students", 1),
          (hasMore.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-indigo-600 hover:text-indigo-500",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showMore()))
              }, "Show " + _toDisplayString(nextBatchSize.value) + " More", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})